/** Real-time notification operations, API Code request.  */
export enum RealTimeNotificationOperation {
    /** A notification on appointment updates (status and time slots). */
    UpdateAppointment,
    /** A notification on call center user state updates. */
    UpdateCallCenterUserState
}
